export const parseLocalDate = (value) => {
  if (!value) return null;

  const [year, month, day] = String(value).split('-').map(Number);
  if (!year || !month || !day) return null;

  return new Date(year, month - 1, day);
};

export const formatLocalDate = (date) => {
  if (!date) return null;

  const pad = (n) => String(n).padStart(2, '0');

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};
